import { render, staticRenderFns } from "./ChatPaletteForm.vue?vue&type=template&id=221d0fd8&lang=pug&"
import script from "./ChatPaletteForm.vue?vue&type=script&lang=js&"
export * from "./ChatPaletteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChatPaletteForm.vue"
export default component.exports